<template>
  <div class="page-content">
    <div class="tab-header-container">
      <h2 class="form-label">Промяна на парола</h2>
    </div>

    <hr class="form-line">

    <form style="padding-top: 20px;">
      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'newPassword'"
                 :name="'newPassword'"
                 :label="'Нова парола'"
                 :hidden="true"
                 :placeholder="'Въведете новата парола'"
                 :newValue="newPassword"
                 :showError="shouldShowError('newPassword')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('newPassword')" :text="errors['newPassword']"/>

      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'repeatNewPassword'"
                 :name="'repeatNewPassword'"
                 :label="'Повторете новата парола'"
                 :hidden="true"
                 :placeholder="'Повторете новата парола'"
                 :newValue="repeatNewPassword"
                 :showError="shouldShowError('repeatNewPassword')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('repeatNewPassword')" :text="errors['repeatNewPassword']"/>

      <div style="width: 100%;">
        <Button class="save-button"
                @click.native="changePassword"
                :color="'green'"
                :text="'Запази'"
                :icon="'fa fa-save'"></Button>
      </div>
    </form>
  </div>
</template>

<script>
import InputText from "@/shared/components/form/InputText";
import Button from "@/shared/components/button/Button";
import ErrorInput from "@/shared/components/form/ErrorInput";
import authorizationService from "@/services/authorization.service";

export default {
  name: "UserResetPassword",
  components: {ErrorInput, Button, InputText},
  created() {
    authorizationService.checkIsLoggedIn();
  },
  data() {
    return {
      userId: this.$route.params.id,
      newPassword: null,
      repeatNewPassword: null,
      errors: {}
    }
  },
  methods: {
    setAttribute(value) {
      this[value.name] = value.currentValue;
      this.errors[value.name] = null;
    },
    changePassword() {
      if (this.newPassword === this.repeatNewPassword) {
        authorizationService.resetPassword({
          id: this.userId,
          password: this.newPassword
        })
            .then(() => {
              alert('Паролата е променена успешно!');
              this.newPassword = null;
              this.repeatNewPassword = null;
            })
            .catch((errors) => this.errors = errors.response.data.errors);
      } else {
        this.errors = {repeatNewPassword: this.repeatNewPassword ? 'Паролите трябва да съвпадат' : 'Не може да е празно'};
      }
    },
    shouldShowError(fieldName) {
      return !!(this.errors && this.errors[fieldName]);
    }
  }
}
</script>

<style scoped>

.input {
  display: block;
  width: 50%;
  height: 95px;
  margin: 20px auto 0 auto;
}

.error {
  width: 50%;
  margin-top: -7px;
}

.save-button {
  width: 300px;
  height: 60px;
  font-size: 26px;
  margin: 45px;
}
</style>
